import React, { useState } from 'react';
import { Modal } from '@mui/material';
import {
  WhatsApp as WhatsAppIcon,
  Facebook as FacebookIcon,
  Close as CloseIcon,
  Reddit as RedditIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
  ContentCopy as ContentCopyIcon,
} from '@mui/icons-material';
import './ShareModal.scss';

const XIcon = () => (
  <svg viewBox="0 0 24 24" style={{ width: '28px', height: '28px', fill: 'currentColor' }}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const ShareModal = ({ isOpen, onClose, article, feed, referral }) => {
  const [copied, setCopied] = useState(false);
  
  if (!article && !feed && !referral) return null;
  
  let shareUrl, shareText, emailText;
  
  if (referral) {
    shareUrl = `${window.location.origin}/referral/${referral.userId}`;
    shareText = `Check out this cool learning tool: ${shareUrl}`;
    emailText = `Check out this cool learning tool:\n\n${shareUrl}`;
  } else if (feed) {
    shareUrl = `${window.location.origin}/feed/${feed.feed_id}`;
    shareText = `Check out this podcast feed: ${feed.title}\n${shareUrl}`;
    emailText = `Check out this podcast feed: ${feed.title}\n\nListen here: ${shareUrl}`;
  } else {
    shareUrl = `https://audioread.com/share/${article.audio_url.split('/').pop().replace('.mp3', '')}`;
    shareText = `Check this out: ${article.title}\n${shareUrl}`;
    emailText = `Check this out: ${article.title}\n\nRead and listen here: ${shareUrl}`;
  }
  
  const shareOptions = [
    {
      name: 'WhatsApp',
      icon: <WhatsAppIcon style={{ color: '#25D366', fontSize: 28 }} />,
      onClick: () => window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`)
    },
    {
      name: 'X',
      icon: <XIcon />,
      onClick: () => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`)
    },
    {
      name: 'Facebook',
      icon: <FacebookIcon style={{ color: '#1877F2', fontSize: 28 }} />,
      onClick: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`)
    },
    {
      name: 'LinkedIn',
      icon: <LinkedInIcon style={{ color: '#0A66C2', fontSize: 28 }} />,
      onClick: () => window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareText)}`)
    },
    {
      name: 'Reddit',
      icon: <RedditIcon style={{ color: '#FF4500', fontSize: 28 }} />,
      onClick: () => window.open(`https://www.reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(article.title)}`)
    },
    {
      name: 'Email',
      icon: <EmailIcon style={{ color: '#666666', fontSize: 28 }} />,
      onClick: () => window.open(`mailto:?subject=${encodeURIComponent(article.title)}&body=${encodeURIComponent(emailText)}`)
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="share-modal-title"
      className="share-modal"
    >
      <div className="share-modal-content">
        <div className="share-modal-header">
          <h2 id="share-modal-title">
            {referral ? 'Share Referral Link' : 'Share Article'}
          </h2>
          <CloseIcon onClick={onClose} className="close-button" />
        </div>
        
        <div className="share-url-container">
          <textarea
            value={shareText}
            readOnly
            className="share-url-input"
            rows={4}
          />
          <button 
            className="copy-button"
            onClick={copyToClipboard}
          >
            <ContentCopyIcon />
            <span>{copied ? 'Link Copied!' : 'Copy Link'}</span>
          </button>
        </div>

        <div className="share-options">
          {shareOptions.map((option) => (
            <button
              key={option.name}
              className="share-option-button"
              onClick={option.onClick}
              aria-label={option.name}
            >
              {option.icon}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal; 